import {
  FIXED_FONT_SIZE,
  LINE_HEIGHT,
  LINES_ALLOWED,
} from './dynamicStyleConstants';

// TODO: mb move this logic to `MainEpisodeList` directory? It's not common logic to be in lib
function getMainEpisodeListImageSize(fonts) {
  if (!fonts.episodeTitleFont || !fonts.episodeDescriptionFont) {
    return;
  }

  const episodeTitleHeight = fonts.episodeTitleFont.size * LINE_HEIGHT.TITLE;
  const episodeMetaInfoHeight = FIXED_FONT_SIZE.META_INFO * LINE_HEIGHT.DEFAULT;
  const episodeDescriptionHeight =
    fonts.episodeDescriptionFont.size *
    LINE_HEIGHT.DEFAULT *
    LINES_ALLOWED.MAIN_EPISODE_DESCRIPTION;

  // TODO: what is 32? Is it ok, to keep it here?
  const magic32 = 32;

  return (
    episodeTitleHeight +
    episodeMetaInfoHeight +
    episodeDescriptionHeight +
    magic32
  );
}

export default getMainEpisodeListImageSize;
